import * as React from "react"

export const UNKNOWN_MODULE_NAME = "unknown"

export const ModuleNameContext = React.createContext<string>(UNKNOWN_MODULE_NAME)
